import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Coins, Sparkles } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface NoCreditsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUpgrade: () => void;
}

export function NoCreditsModal({ open, onOpenChange, onUpgrade }: NoCreditsModalProps) {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto p-4 bg-primary/10 rounded-full mb-4">
            <Coins className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-center text-xl">
            {t('noCredits', 'title')}
          </DialogTitle>
          <DialogDescription className="text-center">
            {t('noCredits', 'description')}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-4">
          <Button
            onClick={onUpgrade}
            className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            <Sparkles className="h-4 w-4 mr-2" />
            {t('noCredits', 'getCredits')}
          </Button>
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
          >
            {t('noCredits', 'maybeLater')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
